import * as React from 'react';
import { render } from 'react-dom';

interface IProps {
  phones: string[];
  oid: string;
  offerRequestReferer: string | void;
  subscribeAbGroup: number;
  userName?: string;
  userMail?: string;
  userPhones?: string[];
}

export default function initCommercialClaims() {
  (window as any).renderCommercialClaims = ({
    phones,
    oid,
    offerRequestReferer,
    subscribeAbGroup,
    userName,
    userMail,
    userPhones,
  }: IProps) => {
    const phoneRoot = document.querySelector('[data-commercial-claims-phone-show]');
    const formRoot = document.querySelector('[data-commercial-claims-form]');

    if (phoneRoot && formRoot && phones) {
      require.ensure(['./components/form/index', './components/phone_show/index'], () => {
        const CommercialClaims = require('./components/form/index').default;
        const PhoneShow = require('./components/phone_show/index').default;
        const customUrl = (window as any)._dataLayerBackedObject.page.customPageURL;

        render(
          <PhoneShow phones={phones} customUrl={customUrl} />,
          phoneRoot
        );

        render(
          <CommercialClaims
            name={userName}
            mail={userMail}
            phone={userPhones}
            oid={oid}
            customUrl={customUrl}
            offerRequestReferer={offerRequestReferer}
            subscribeAbGroup={subscribeAbGroup} />,
          formRoot
        );
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/bundles/commercial_claims/index.tsx